module.exports = __webpack_public_path__ + "static/img/pay-six.d4da1b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pay-six.png
// module id = LXnN
// module chunks = 0